import React from "react";

const CertificateMessage = ({ purpose }) => {
  return (
    <p style={wrapper}>
       {`The certificate has been issued to him for `}
      <span style={boldStyle}>{purpose}</span>
      {`, will not be valid for any other purpose.`}
    </p>
  );
};

const wrapper = {
  marginTop: "5%",
};

const boldStyle = {
  fontWeight: "bold",
};

export default CertificateMessage;
